import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

const defaultProps = {
  className: ''
};

export default class PageLayout extends Component {
  render() {
    const classes = [this.props.className, 'rec-page-layout-full-width'].filter((v) => v !== "").join(' ');

    return (
      <div className={classes}>
        {this.props.children}
      </div>
    );
  }
}

PageLayout.propTypes = propTypes;
PageLayout.defaultProps = defaultProps;
